define("Modules/Avatar", [`Module`, `module`], function (Super, Self) {
	return Super.inherit({
		namespace: Self.id,
		requires: [`User`],
		defaults: {
			render: true,
			showMenu: true,
			size: `small`,
		},
		constructor(setup) {
			const { elements } = this;

			this.assign(elements, {
				linkElement: this.get(`[action="log-in"]`),
				initialsElement: this.get(`.initials`),
				popoverElement: this.get(`.popover`),
			});

			if (setup.showMenu) {
				this.addClass(`show-menu`);
			}

			this.addClass(setup.size);

			this.hide({
				target: [elements.linkElement, elements.initialsElement, elements.popoverElement],
				done: true,
			});

			return this.User.get({
				subscribe: true,
				then: function (user) {
					const isGuestUser = this.User.isGuestUser();

					if (isGuestUser) {
						this.handleLoggedOut();
					} else {
						this.handleLoggedIn(user);
					}
				},
				fail: this.handleLoggedOut,
			});
		},
		api: {
			/**
			 * Updates the UI if the user is logged in.
			 * @param {Object} user
			 */
			handleLoggedIn: {
				value(user) {
					const { linkElement, initialsElement, popoverElement } = this.elements;

					// logged in
					if (this.isObject(user.avatar)) {
						initialsElement.innerHTML = user.avatar.initials;
					}

					return this.hide({
						target: linkElement,
						then: function () {
							return this.show({
								target: [initialsElement, popoverElement],
							});
						},
					});
				},
			},

			/**
			 * Updates the UI if the user is logged out.
			 */
			handleLoggedOut: {
				value() {
					const { linkElement, initialsElement, popoverElement } = this.elements;

					// logged out
					return this.hide({
						target: [initialsElement, popoverElement],
						then: function () {
							return this.show({
								target: linkElement,
							});
						},
					});
				},
			},
		},
		listeners: [
			{
				event: `click`,
				filter: `[action]`,
				handler(evt) {
					var link = evt.currentTarget,
						action = link.getAttribute(`action`);

					switch (action) {
						case `log-in`:
							this.App.loadOverlay({
								type: `LogIn`,
								replace: true, // don't keep this overlay running
								setup: {
									mode: `default`,
								},
								done: true,
							});
							break;

						case `log-out`:
							this.User.logOut({
								done: true,
							});
							break;
					}
				},
			},
		],
	});
});

define("Modules/Avatar.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Modules/Avatar/main"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a href=\"#\" action=\"log-in\">Log In</a> <div class=\"initials\" translate=\"no\"> <span class=\"label\"></span> </div> <div class=\"hover-wrapper\"> <div class=\"popover\"> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"diamond",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":162},"end":{"line":1,"column":183}}}))
    + " <a href=\"/home/events\">My Events</a> <a href=\"/home/media\">My Media</a> <a href=\"/home/orders\">My Orders</a> <a href=\"/home/transfers\">My Transfers</a> <a href=\"/home/payment\">Payment Method</a> <a href=\"/home/profile\">My Profile</a> <hr /> <a href=\"/logout\">"
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"power",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":443},"end":{"line":1,"column":462}}}))
    + "Log Out</a> </div> </div>";
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=Avatar.js.map